import React from "react";
import { generatePath, useNavigate } from "react-router-dom";
import { track } from "../../../services/analytics";

interface NoticiaData {
  ID: number;
  Title: string;
  Descricao: string;
  Categoria?: {
    Title: string;
  };
  DataInicio: string;
  UrlIcone: string;
}

interface NoticiaCardProps {
  item: NoticiaData;
}

const NoticiaCard: React.FC<NoticiaCardProps> = ({ item }) => {
  const navigate = useNavigate();

  const normalizeCategory = (category?: string) =>
    category
      ?.normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");

  const formatDateAno = (dateUtc: string) => {
    if (dateUtc) {
      return (
        new Date(dateUtc).getDate() +
        " de " +
        new Date(dateUtc)
          .toLocaleString("pt-BR", { month: "long" })
          .toString() +
        " de " +
        new Date(dateUtc).getFullYear().toString()
      );
    }
    return "";
  };

  const ReplaceUrl = (url: string) => {
    if (url) {
      return url.replace("http:", "https:"); 
    } else {
      return "../assets/img/noticias-default.png";
    }
  };

  const Setlocation = (noticia: NoticiaData, nav: boolean) => {
    const url = noticia.Title;
    const Id = noticia.ID;
    let urlParamTrim = url
      ?.substring(0, 50)
      .normalize("NFD")
      .replace(/[^a-zA-Z\s]/g, "")
      .replace(/\s+/g, "-");

    if (urlParamTrim === undefined || urlParamTrim == null) {
      urlParamTrim = "Noticias...";
    } else {
      urlParamTrim = urlParamTrim + "...";
    }

    const searchParams = new URLSearchParams(urlParamTrim);
    searchParams.set("Id", Id.toString());
    const path = "/noticias-internas/" + searchParams.toString();

    if (nav) {
      navigate(generatePath(path));
    } else {
      return generatePath(path);
    }
  };

  const addDefaultSrcFiltro = (
    ev: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    ev.currentTarget.src = "../assets/img/noticias-default.png";
  };

  return (
    <div className="noticia-card">
      <a
        href={Setlocation(item, false)}
        className="noticia-card-link"
        onClick={() =>
          track("noticia_clique", {
            identificador: item.ID,
            categoria: normalizeCategory(item.Categoria?.Title),
            origem: "home",
          })
        }
      >
        {/* Header do Card */}
        <div className="noticia-card-header">
          <div className="noticia-card-category">
            {item.Categoria?.Title?.toUpperCase()}
          </div>
          
        </div>

        {/* Imagem do Card */}
        <div className="noticia-card-image">
          <img
            src={ReplaceUrl(item.UrlIcone)}
            onError={addDefaultSrcFiltro}
            alt="Imagem da notícia"
          />
        </div>

        {/* Descrição do Card */}
        <div>
          <h3 className="noticia-card-title">{item.Title}</h3>
        </div>

        {/* Data */}
        <div className="noticia-card-date">
          <p>{formatDateAno(item.DataInicio)}</p>
        </div>

        {/* Ícone de Link */}
        <div className="noticia-card-link-icon">
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 1V9"
              stroke="#F08921"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 5H9"
              stroke="#F08921"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </a>
    </div>
  );
};

export default NoticiaCard;
